import setHiddenSlides from '../../../../src/js/set-hidden-slides';

// eslint-disable-next-line no-undef
new Swiper('.block-testimonial-slider__slider', {
	a11y: {
		slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
	},
	on: {
		init: setHiddenSlides,
		slideChangeTransitionEnd: setHiddenSlides,
		breakpoint: setHiddenSlides,
	},
	slidesPerView: 1,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: false,
	},
	navigation: {
		nextEl: '.block-testimonial-slider__next',
		prevEl: '.block-testimonial-slider__prev',
	},
});
